import React, { useContext } from 'react'
import { Redirect, Route } from 'react-router'
import { StarterContext } from '../../store/Starter'
function Auth({ component:Cmp, ...rest }) {
    const {auth}=useContext(StarterContext)
    return (
        <Route
            {...rest}
            render={(props) =>
                (auth.login) ? <Cmp {...props} />:<Redirect to='/'/>
            }
        />
    )
}

export default Auth
